<template>
  <div class="show-document-container">
    <confirmation-dialog
      :show="showDeleteDialog"
      confirmation-message="Are you sure to delete?"
      @onConfirm="deleteDocument"
      @onNotConfirm="showDeleteDialog=false"
      ></confirmation-dialog>

    <weex-text
      v-if="getDisplayName"
      class="bottom-line font-size-sm-base font-weight-bold padding-5"
      v-html="getDisplayName"
      ></weex-text>

    <weex-text
      v-if="getComments"
      class="font-style-italic text-color-gray font-size-sm-base margin-top-5"
      v-html="getComments"
      ></weex-text>

    <div class="item-row-alignment horizontal-center margin-top-20">
      <button-with-image
        v-if="allowReUpload"
        style="margin-left: 2px; margin-right: 2px"
        text="Re-upload"
        size="small"
        :enabled-btn-style="actionButtonStyle"
        :enabled-text-style="{color: 'blue'}"
        :image-src="uploadImageSrc"
        @onButtonClicked="onReUploadDocumentClicked"
        ></button-with-image>

      <button-with-image
        v-if="allowDelete"
        style="margin-left: 2px; margin-right: 2px"
        text="Delete"
        size="small"
        :enabled-btn-style="actionButtonStyle"
        :enabled-text-style="{color: 'red'}"
        :image-src="deleteImageSrc"
        @onButtonClicked="onDeleteDocumentClicked"
        ></button-with-image>

      <button-with-image
        v-if="showAddPasswordButton"
        style="margin-left: 2px; margin-right: 2px"
        text="Add Password"
        size="small"
        :enabled-btn-style="actionButtonStyle"
        :enabled-text-style="{color: 'gray'}"
        :image-src="addPasswordImageSrc"
        @onButtonClicked="onAddPasswordClicked"
        ></button-with-image>
    </div>
  </div>
</template>

<script>

  import ConfirmationDialog from "../dialogs/ConfirmationDialog";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import ButtonWithImage from "./ButtonWithImage";
  import { DocumentStatus, DocumentStatusValueToDocumentStatus } from "../../utils/DocumentDetails";

  export default {
    name: "ShowDocumentItem",
    components: { ConfirmationDialog, ButtonWithImage },
    data: () => ({
      showDeleteDialog: false
    }),

    props: {
      document: {
        type: Object,
        required: true,
        default: () => ({})
      },

      allowDelete: {
        type: Boolean,
        default: true
      },

      allowReUpload: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      onReUploadDocumentClicked() {
        this.$emit('onDocumentReUpload', this.document)
      },

      onDeleteDocumentClicked() {
        this.showDeleteDialog = true;
      },

      onAddPasswordClicked() {
        this.$emit('onAddPassword', this.document);
      },

      deleteDocument() {
        this.$emit('onDocumentDelete', this.document);
        this.showDeleteDialog = false;
      },
    },

    computed: {
      getDisplayName() {
        let displayName = "";
        if (this.document) {
          if (this.document.displayName) {
            displayName = this.document.displayName;
          } else if (this.document.name) {
            displayName = this.document.name;
          }
        }

        return displayName;
      },

      getComments() {
        return this.document ? this.document.comments : "";
      },

      showAddPasswordButton() {
        const status = this.document && this.document.verified ? this.document.verified.value : "";
        return status
          && DocumentStatusValueToDocumentStatus[status] === DocumentStatus.PASSWORD_PENDING;
      },

      actionButtonStyle() {
        return {
          backgroundColor: "white",
          borderColor: "gray",
          borderWidth: "1px",
          borderStyle: "solid",
          width: "33%"
        }
      },

      deleteImageSrc() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.DELETE);
      },

      addPasswordImageSrc() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.PASSWORD);
      },

      uploadImageSrc() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.UPLOAD);
      },
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .show-document-container {
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    background: white;
    border-color: #238FFF;
    border-width: 1px;
    border-style: solid;
    border-radius: 10px;
  }
</style>
